import filesize from "file-size";
import bytes from "bytes";

export const stringToBytes = (string) => {
  const units = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let totalBytes = 0;

  units.forEach((unit, index) => {
    if (string.toLowerCase().includes(unit.toLowerCase()) && index !== 0) {
      //this unit is used
      totalBytes = bytes(string);
    }
  });

  return totalBytes;
};

export const bytesToString = (bytes) => {
  const size = filesize(bytes).human("jedec");

  return {
    value: parseFloat(size),
    unit: size.slice(-2).toLowerCase(),
  };
};
